module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-b1cc201f826b667d6a4dd8ee0a2ea515.jpg";